export function isLocalLink(url = '') {
  return url.slice(0, 4) !== 'http';
}
